// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M19.3175 3.05085L20.8863 2.26995L21.6672 0.701172L22.4481 2.26996L24.0169 3.05085L22.4481 3.83175L21.6672 5.40053L20.8863 3.83175L19.3175 3.05085Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.05475 3.71882L7.95764 1.51477L6.86054 3.71882L4.6565 4.81592L6.86054 5.91302L7.95764 8.11706L9.05475 5.91302L11.2588 4.81592L9.05475 3.71882Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17.5544 13.3825L12.4057 8.23379L2.14819 18.4913L7.29695 23.64L17.5544 13.3825Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22.3861 8.55085L17.2373 3.4021L13.8201 6.81934L18.9688 11.9681L22.3861 8.55085Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-filter-2-filled')
export default class Filter2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'filter-2-filled',
    }
  }
}
